module.exports = __webpack_public_path__ + "img/industrial-cut.9e4441c9.jpg";